import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import Modal from "react-bootstrap/Modal";
import { format } from "date-fns";

const ViewLeadModal = (props) => {
  const closeModal = () => {
    props.setIsModalOpen(false);
  };

  const singleleadData = props.singleLeadData;
console.log('Data inside view lead modal--', singleleadData)
const formattedDate = singleleadData?.leadStatus?.timeAndDate
  ? format(new Date(singleleadData.leadStatus.timeAndDate), "dd MMM yyyy, hh:mm a")
  : "";
  console.log('Formatted date', formattedDate)

  return (
    <>
      <Modal
        show={props.isModalOpen}
        onHide={closeModal}
        backdrop="static"
        size="md"
      >
        <div className="modal-header">
          <h4 className="modal-title">View Lead Details</h4>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModal}
          ></button>
        </div>
        <div className="modal-body">
          {singleleadData ? (

              <div className="row">
                  
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    <div className="form-group">
                      <label className="mb-1">Name</label>
                      <p>{singleleadData?.name}</p>
                    </div>
                  </div>               

                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    <div className="form-group">
                      <label className="mb-1">Email</label>
                      <p>{singleleadData?.email}</p>
                    </div>
                  </div>

                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    <div className="form-group">
                      <label className="mb-1">Phone Number </label>
                      <p>{singleleadData?.phoneNo}</p>
                    </div>
                  </div>

                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    <div className="form-group">
                      <label className="mb-1">Message </label>
                      <p>{singleleadData?.message}</p>
                    </div>
                  </div>

                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    <div className="form-group">
                      <label className="mb-1">Lead Status</label>
                      <p>
                         <span className={
                            singleleadData?.leadStatus?.status === "closed"
                              ? "badge  bg-opacity-10 closed-color"
                              : singleleadData?.leadStatus?.status === "rejected"
                              ? "badge  bg-opacity-10 canceled-color"
                              : singleleadData?.leadStatus?.status === "cancelled"
                              ? "badge  bg-opacity-10 canceled-color"
                              : singleleadData?.leadStatus?.status === "forwarded"
                              ? "badge forwardrequested-color bg-opacity-10"
                              : "badge pending-color bg-opacity-10"
                              }>
                              {singleleadData?.leadStatus?.status}    
                         </span>
                       </p>
                    </div>
                  </div>

                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                     {singleleadData?.leadStatus?.forwardedTo && (
                    <div className="form-group">
                      <label className="mb-1">Forwarded To </label>
                      <p>{singleleadData.leadStatus.forwardedTo}</p>
                    </div>
                    )}
                  </div>

                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    {singleleadData?.leadStatus?.reason && (
                    <div className="form-group">
                      <label className="mb-1">Reason</label>
                      <p>{singleleadData.leadStatus.reason}</p>
                    </div>
                       )}
                  </div>

                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    <div className="form-group">
                      <label className="mb-1">Date & Time</label>
                      <p>{formattedDate}</p>
                    </div>
                  </div>

                </div>
            
            // <table className="table table-bordered modal-table">
            //   <tbody>
            //     <tr>
            //       <th>Name</th>
            //       <td>{singleleadData?.name}</td>
            //     </tr>
            //     <tr>
            //       <th>Email</th>
            //       <td>{singleleadData?.email}</td>
            //     </tr>
            //     <tr>
            //       <th>Phone Number</th>
            //       <td>{singleleadData?.phoneNo}</td>
            //     </tr>
            //     {singleleadData?.message && (
            //       <tr>
            //         <th>Message</th>
            //         <td>
            //         <p>{singleleadData?.message}</p>
            //       </td>
            //       </tr>
            //     )}
            //     <tr>
            //       <th>Lead Status</th>
            //       <td>
            //         <span className={
            //                 singleleadData?.leadStatus?.status === "closed"
            //                   ? "badge  bg-opacity-10 closed-color"
            //                   : singleleadData?.leadStatus?.status === "rejected"
            //                   ? "badge  bg-opacity-10 canceled-color"
            //                   : singleleadData?.leadStatus?.status === "cancelled"
            //                   ? "badge  bg-opacity-10 canceled-color"
            //                   : singleleadData?.leadStatus?.status === "forwarded"
            //                   ? "badge forwardrequested-color bg-opacity-10"
            //                   : "badge pending-color bg-opacity-10"
            //         }>
            //         {singleleadData?.leadStatus?.status}    
            //     </span>
            //     </td>
            //     </tr>
            //     {singleleadData?.leadStatus?.forwardedTo && (
            //       <tr>
            //         <th>Forwarded To</th>
            //         <td>{singleleadData.leadStatus.forwardedTo}</td>
            //       </tr>
            //     )}

            //     {singleleadData?.leadStatus?.reason && (
            //       <tr>
            //         <th>Reason</th>
            //         <td>{singleleadData.leadStatus.reason}</td>
            //       </tr>
            //     )}

            //     <tr>
            //       <th>Date & Time</th>
            //       <td>
            //         {formattedDate}
            //       </td>
            //     </tr>
            //   </tbody>
            // </table>
          ) : (
            <p>Loading lead details...</p>
          )}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={closeModal}
            className="add-minutes Mom-btn"
          >
            <p>Close</p>
          </button>
        </div>
      </Modal>
    </>
  );
};

export default ViewLeadModal;
